import { RefreshCw, Settings } from 'lucide-react';

/**
 * Toolbar of the Availability images dialog: a gear that opens the image
 * settings (font sizes in px, BOOKED colours — see
 * AvailabilityImageSettingsModal) and the button that regenerates every image.
 *
 * Neither button is ever disabled: the images render in the background, and
 * pressing either one mid-run simply restarts the work with the new choice.
 *
 * @param {object} props
 * @param {() => void} props.onOpenSettings
 * @param {() => void} props.onRegenerate
 * @param {boolean} props.generating - work in progress; spins the Regenerate icon
 * @returns {JSX.Element}
 */
function AvailabilityTextSizeControls({ onOpenSettings, onRegenerate, generating }) {
  return (
    <div className="aim-controls">
      <button
        type="button"
        className="aim-settings-btn"
        onClick={onOpenSettings}
        aria-label="Image settings"
        title="Image settings"
      >
        <Settings size={18} strokeWidth={2.2} aria-hidden="true" />
      </button>
      <button
        type="button"
        className={`aim-regenerate-btn${generating ? ' aim-regenerate-busy' : ''}`}
        onClick={onRegenerate}
        aria-busy={generating}
      >
        <RefreshCw size={16} strokeWidth={2.2} aria-hidden="true" />
        Regenerate
      </button>
    </div>
  );
}

export default AvailabilityTextSizeControls;
